import React, { useEffect, useState } from "react";
import { getAllUsers, deleteUser } from "../../api/UserApi";
import AddUserModal from "./AddUserModal";
import { toast } from "../shared/Toast";
import { showConfirm } from "../shared/ConfirmContext";
import "./UserManagement.css";

const UserManagement = () => {

    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showAddModal, setShowAddModal] = useState(false);

    const fetchUsers = async () => {
        try {
            setLoading(true);

            const data = await getAllUsers();

            setUsers(data);

        } catch (error) {

            console.log(error);
            toast.error("Failed to load users");

        } finally {

            setLoading(false);

        }
    };

    useEffect(() => {

        fetchUsers();

    }, []);

    const handleDelete = async (id) => {

        const confirmDelete = await showConfirm({
            title: "Delete User",
            message: "Are you sure you want to delete this user?",
            danger: true,
            confirmLabel: "Delete",
            cancelLabel: "Cancel",
        });

        if (!confirmDelete) return;

        try {

            await deleteUser(id);

            toast.success("User deleted successfully");

            fetchUsers();

        } catch (error) {

            console.log(error);

            toast.error("Unable to delete user");

        }

    };

    return (

        <div className="user-management">

            <div className="user-header">

                <h2>User Management</h2>

                <button
                    className="add-user-btn"
                    onClick={() => setShowAddModal(true)}
                >
                    + Add User
                </button>

            </div>

            {
                loading ?

                    <p className="loading">Loading...</p>

                    :

                    <table className="user-table">

                        <thead>

                            <tr>

                                <th>Name</th>
                                <th>Email</th>
                                <th>Role</th>
                                <th>Action</th>

                            </tr>

                        </thead>

                        <tbody>

                            {
                                users.length === 0 ?

                                    <tr>

                                        <td
                                            colSpan="4"
                                            className="no-users"
                                        >
                                            No Users Found
                                        </td>

                                    </tr>

                                    :

                                    users.map((user) => (

                                        <tr key={user.id}>

                                            <td>{user.name}</td>

                                            <td>{user.email}</td>

                                            <td>{user.role}</td>

                                            <td>

                                                <button
                                                    className="delete-btn"
                                                    onClick={() => handleDelete(user.id)}
                                                >
                                                    Delete
                                                </button>

                                            </td>

                                        </tr>

                                    ))
                            }

                        </tbody>

                    </table>

            }

            {
                showAddModal && (

                    <AddUserModal
                        close={() => setShowAddModal(false)}
                        refresh={fetchUsers}
                    />

                )
            }

        </div>

    );

};

export default UserManagement;